import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import Heading from "../../../../../../common/element/Heading/index.js";
import BtnLight from "../../../../../../common/element/Buttons/btnLight.js";
import Dropdown from "../../../../../../common/element/Dropdown/Dropdown.js";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice.js";
// import PieChart from "../ProviderUnderAClient/PieChartUnderAClient.js";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Pagination } from "../../../../../../common/pagination/index.js";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler.js";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader/index.js";
import ThreeDotLoader from "../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import { notify } from "react-notify-toast";
import ReactPaginate from "react-paginate";
import ClientMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ClientMultiSelectDropdown.js";
import StatusMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/StatusMultiSelectDropdown.js";
import DateMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/DateMultiSelectDropdown.js";
import ProviderMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ProviderMultiSelectDropdown.js";
import SiteMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/SiteMultiSelectDropdown.js";
import moment from "moment";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary.js";
import Input from "../../../../../../common/element/Input/Input.js";
import { ProviderGetAllfavouriteReports ,ProviderFavouriteReportsOrNot} from "../../../../../../actions/admin-provider/worker/ProviderReportFavOrNot";
import { FetchAllProviderCustomReports, ProviderCustomReports } from "../../../../../../actions/admin-provider/reports/CustomReportForProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import logoPDF from "./LogoPDF.png";
import Dialog from "../../../../../../common/element/Dialog/Dialog.js";
import { GenerateProviderChecklistOverviewReport } from "../../../../../../actions/admin-provider/reports/GenerateProviderChecklistOverviewReport.js";
import DataList from "./DataList.js";
import CheckListMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/CheckListMultiSelectDropdown.js";
import { GenerateProviderOverviewReport } from "../../../../../../actions/admin-provider/reports/GenerateProviderOverviewReport.js";
import { GenerateProviderOverviewReportFunction } from "../../../../../../actions/Admin/reports/GenerateProviderOverviewReportFunction.js";
import PieChart from "./PieChartUnderAClient.js";
import LineChart from "./OverViewChart.js";
import AllProviderMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/AllProviderMultiSelectDropdown.js";
import AssignClientMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/AssignClientMultiSelectDropdown.js";
import ProvideTyperMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ProvideTyperMultiSelectDropdown.js";
const ProvidersComplianceChecklist = () => {
  const csvLinkRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()
  const { favReport, cstRep } = location.state || {};

  const [selectReport, setSelectReport] = useState(false);
  const [openSuccessDialog,setOpenSuccessDialog]=useState(false)
  const [saveCustomRep, setSaveCustomRep] = useState(false)
  const [unSaveDialogIsOpen, unSaveSetIsOpen] = useState(false);
  const [removeDilaog, setRemoveDialog] = useState(false);
  const [custReportName, setCustReportName] = useState("")
  const [custSuccessMsg,setCustSuccessMsg]=useState(false);
  const [custErrMsg, setCustErrMsg] = useState("")
  const [reportData, SetReportData] = useState(null);
  const [loadData, setLoadData] = useState(false);
  const [processedCsvData, setProcessedCsvData] = useState([]);
  const [checkPdfLoad, setCheckPdfLoad] = useState(true);
  const [successText, setSuccessText] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [key, setKey] = useState("custom");
  const [pdfDownloadSuccessDialog, setPdfDownloadSuccessDialog] =
    useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  // const [dateMinMax, setDateMinMax] = useState({
  //   lowestDate: null,
  //   greatestDate: null,
  // });

  const [dateMinMax, setDateMinMax] = useState({
    creation_date_range: { lowestDate: null, greatestDate: null },
    approval_date_range: { lowestDate: null, greatestDate: null },
    renewal_date_range: { lowestDate: null, greatestDate: null },
  });

  const [getAllinvitedData, SetgetAllinvitedData] = useState({
    search: "",
    client_org_ids: [],
    provider_org_ids: [],
    provider_type_ids: [],
    status: "",
    approval_date_range: "",
    renewal_date_range: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
  });

  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  let userType;
  let userId;
  if (storedData) {
    userId = storedData?.userName?.user_id;
    userType = storedData?.data?.role?.role_name
  }
  const calculateMinMaxDate = useCallback((data, dateType) => {
    const timestamps = data
      ?.map((item) => new Date(item?.[dateType])?.getTime())
      .filter(Boolean);

    if (!timestamps?.length) {
      return { lowestDate: null, greatestDate: null };
    }

    return {
      lowestDate: new Date(Math.min(...timestamps)),
      greatestDate: new Date(Math.max(...timestamps)),
    };
  }, []);

  const updateReportState = useCallback(
    (data = {}, filters = {}) => {
      const providers = Array.isArray(data?.providers) ? data.providers : [];
      const statistics = {
        ...(data?.statistics || {}),
        monthlyStatus: Array.isArray(data?.statistics?.monthlyStatus)
          ? data.statistics.monthlyStatus
          : [],
      };

      SetReportData({
        ...data,
        providers,
        statistics,
      });

      setDateMinMax({
        creation_date_range: calculateMinMaxDate(providers, "creation_date"),
        approval_date_range: calculateMinMaxDate(providers, "approval_date"),
        renewal_date_range: calculateMinMaxDate(providers, "renewal_date"),
      });

      const resolvedLimit = Number(filters?.limit) || providers.length || 1;
      const totalRecords = Number(data?.total) || providers.length;
      setTotalPages(Math.ceil(totalRecords / resolvedLimit));
    },
    [calculateMinMaxDate]
  );

  const fetchProviderOverview = useCallback(
    async (filters) => {
      if (!filters) return null;
      setLoadData(false);

      try {
        const response = await dispatch(
          GenerateProviderOverviewReport(filters)
        );

        if (response?.success) {
          updateReportState(response?.data, filters);
        } else if (response?.status === 401) {
          handleUnauthorizedAccess();
        }

        return response;
      } catch (error) {
        console.error("❌ Error fetching provider overview:", error);
        return null;
      } finally {
        setLoadData(true);
      }
    },
    [dispatch, handleUnauthorizedAccess, updateReportState]
  );

  const latestFiltersRef = useRef(null);
  const loadingTimeoutRef = useRef();
  const isInitialFetchRef = useRef(true);

  useEffect(() => {
    const stringifiedFilters = JSON.stringify(getAllinvitedData);

    if (isInitialFetchRef.current) {
      isInitialFetchRef.current = false;
      latestFiltersRef.current = stringifiedFilters;
      fetchProviderOverview(getAllinvitedData);
      return () => clearTimeout(loadingTimeoutRef.current);
    }

    if (latestFiltersRef.current === stringifiedFilters) {
      return;
    }

    latestFiltersRef.current = stringifiedFilters;

    clearTimeout(loadingTimeoutRef.current);

    const filtersSnapshot = JSON.parse(stringifiedFilters);

    loadingTimeoutRef.current = setTimeout(() => {
      fetchProviderOverview(filtersSnapshot);
    }, 100);

    return () => clearTimeout(loadingTimeoutRef.current);
  }, [getAllinvitedData, fetchProviderOverview]);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Reports",
          url: "/admin/reports",
          home: "/admin/provider/dashboard",
        },
        {
          label: "Providers Overview ",
          url: "/admin/provider/reports/provider-overview",
        },
      ])
    );
  }, [dispatch]);
  const handleSort = (empty, column) => {
    // if (column === getAllinvitedData.sort) {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["order"]: getAllinvitedData.order === "asc" ? "desc" : "asc",
        ["sort"]: column,
      };
    });
  };

  const handlePageChange = ({ selected }) => {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["page"]: selected + 1,
      };
    });
  };

  const updateFilter = (fieldName, value) => {
    SetgetAllinvitedData((prevalue) => {
      const normalizeSelections = (items, keys) => {
        if (!Array.isArray(items)) return [];

        return items
          .map((item) => {
            if (item && typeof item === "object") {
              const selection = keys.reduce((acc, key) => {
                if (item[key] !== undefined) {
                  acc[key] = item[key];
                }
                return acc;
              }, {});

              return Object.keys(selection).length ? selection : null;
            }

            if (typeof item === "number" || typeof item === "string") {
              const parsed = Number(item);
              return Number.isNaN(parsed) ? null : { [keys[0]]: parsed };
            }

            return null;
          })
          .filter(Boolean);
      };

      const nextValue = (() => {
        switch (fieldName) {
          case "client_org_ids":
            return normalizeSelections(value, ["organisation_id", "function_assignment_id"]);
          case "provider_org_ids":
            return normalizeSelections(value, ["provider_org_id", "f_a_relation_id"]);
          case "provider_type_ids":
            return Array.isArray(value) ? value : [];
          default:
            return value;
        }
      })();

      const hasChanged =
        Array.isArray(nextValue) || Array.isArray(prevalue[fieldName])
          ? JSON.stringify(prevalue[fieldName] || []) !== JSON.stringify(nextValue || [])
          : prevalue[fieldName] !== nextValue;

      return {
        ...prevalue,
        [fieldName]: nextValue,
        ["page"]: hasChanged && fieldName !== "page" ? 1 : prevalue.page,
        ["limit"]:
          fieldName === "limit" && typeof nextValue === "number"
            ? nextValue
            : prevalue.limit,
      };
    });
  };

  const csvHeaders = [
    { label: "Client Contact", key: "client_contact_name" },
    { label: "Provider", key: "provider_trading_name" },
    { label: "ABN/NZBN", key: "provider_abn_nzbn" },
    { label: "Clients Assigned", key: "client_trading_name" },
    { label: "Status", key: "status" },
    { label: "Reason", key: "change_reason" },
    { label: "State", key: "state_name" },
    { label: "Workers No.", key: "worker_assigned" },
    { label: "Creation Date", key: "creation_date" },
    { label: "Approval Date", key: "last_doc_approval_date" },
    { label: "Renewal date", key: "renewal_date" },
    { label: "Lifetime Value", key: "life_time_value" },
  ];

  const generateProviderOverview = async () => {
    try {
      setIsGenerating(true);
      setLoadData(false);

      const response = await dispatch(
        GenerateProviderOverviewReportFunction(getAllinvitedData)
      );

      if (response?.status === 401) {
        handleUnauthorizedAccess();
        setLoadData(true);
        notify.show(
          "Unable to generate report due to authorization error.",
          "error",
          3000
        );
        return;
      }

      if (response?.success) {
        const refreshed = await fetchProviderOverview(getAllinvitedData);

        if (refreshed?.success === true) {
          notify.show(
            response?.message ||
              "Providers Overview report generated successfully",
            "success",
            3000
          );
        } else if (refreshed?.status === 401) {
          notify.show(
            "Unable to refresh data due to authorization error.",
            "error",
            3000
          );
        } else {
          notify.show(
            "Unable to refresh report data. Please try again.",
            "error",
            3000
          );
        }
      } else {
        setLoadData(true);
        notify.show(
          response?.message || "Unable to generate report. Please try again.",
          "error",
          3000
        );
      }
    } catch (error) {
      console.error('❌ Error generating report:', error);
      setLoadData(true);
      notify.show("Error generating report. Please try again.", "error", 3000);
    } finally {
      setIsGenerating(false);
    }
  };

  function getBase64ImageFromUrl(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      // Enable cross-origin loading if necessary
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });
  }

  const GetPDFAllData = async () => {
    setPdfDownloadSuccessDialog(true);
    let Payload = {
      search: getAllinvitedData?.search,
      provider_org_ids: getAllinvitedData?.provider_org_ids,
      provider_type_ids: getAllinvitedData?.provider_type_ids,
      client_org_ids: getAllinvitedData?.client_org_ids,
      status: getAllinvitedData?.status,
      sort: getAllinvitedData?.sort,
      order: getAllinvitedData?.order,
      approval_date_range: getAllinvitedData?.approval_date_range,
      renewal_date_range: getAllinvitedData?.renewal_date_range,
    };
    try {
      const response = await dispatch(GenerateProviderOverviewReport(Payload));
      if (response.success) {
        setPdfDownloadSuccessDialog(true);
        return response.data; // Return the response data
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
      }
    } catch (error) {
      console.error("Error fetching PDF data:", error);
      setPdfDownloadSuccessDialog(true);
    } finally {
      setPdfDownloadSuccessDialog(true);
    }
    return null; // Return null if the request is not successful
  };

  const handleExport = async (format) => {
    setSuccessText(format);
    try {
      // Wait for data from GetPDFAllData
      const allReportData = await GetPDFAllData();

      if (!allReportData) {
        setCheckPdfLoad(false);
        console.error("Failed to fetch report data.");
        return;
      }
      setCheckPdfLoad(false);

      const getExportValue = (item, key) => {
        if (key === "status") {
          let st = item?.[key];
          if (st === "Assigned") return "Registered";
          if (st === "Registered") return "Self-Registered";
          if (st === "No-clients") return "Self-Registered";
          if (st === "Closed" || st === "Inactive") return "Deactivated";
          return st || "-";
        }
        return item?.[key];
      };

      if (format === "csv") {
        setProcessedCsvData(
          allReportData?.providers?.map((item) => {
            return csvHeaders.reduce((newItem, header) => {
              let value = getExportValue(item, header.key);
              if (
                (header.key.toLowerCase().includes("creation_date") && value) ||
                header.key.toLowerCase().includes("approval_date")
              ) {
                value = moment(value).format("DD/MM/YYYY");
              }
              newItem[header.key] = value ?? "-";
              return newItem;
            }, {});
          })
        );
      } else if (format === "excel") {
        // Create a header row using the labels from csvHeaders.
        const headerRow = csvHeaders.map((header) => header.label);

        const dataRows = allReportData?.providers?.map((item) =>
          csvHeaders.map((header) => {
            const v = getExportValue(item, header.key);
            return v === undefined || v === null ? "-" : v;
          })
        );

        // Combine header and data rows.
        const exportData = [headerRow, ...dataRows];

        // Convert the AOA to a worksheet.
        const ws = XLSX.utils.aoa_to_sheet(exportData);

        // Step 1: Set column widths for better readability in Excel/LibreOffice.
        const widthByKey = {
          client_contact_name: 24,
          provider_trading_name: 28,
          provider_abn_nzbn: 16,
          client_trading_name: 28,
          status: 14,
          change_reason: 22,
          state_name: 18,
          worker_assigned: 12,
          creation_date: 14,
          last_doc_approval_date: 14,
          renewal_date: 14,
          life_time_value: 16,
        };
        ws["!cols"] = csvHeaders.map((h) => ({
          wch: widthByKey[h.key] || Math.max(12, String(h.label || "").length + 2),
        }));

        // Step 2: Best-effort wrap text (depends on XLSX writer support).
        const ref = ws["!ref"];
        if (ref) {
          const range = XLSX.utils.decode_range(ref);
          for (let r = range.s.r; r <= range.e.r; r += 1) {
            for (let c = range.s.c; c <= range.e.c; c += 1) {
              const addr = XLSX.utils.encode_cell({ r, c });
              const cell = ws[addr];
              if (!cell) continue;
              cell.s = cell.s || {};
              cell.s.alignment = {
                ...(cell.s.alignment || {}),
                wrapText: true,
                vertical: "top",
              };
            }
          }
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Save the Excel file.
        XLSX.writeFile(wb, "tableData.xlsx", { cellStyles: true });
      } else if (format === "pdf") {
        const doc = new jsPDF("l"); // Set to landscape mode
        const today = moment().format("DD/MM/YYYY");
        // Set font and add date (top left)
        doc.setFontSize(12);
        doc.text(today, 14, 15);
        // Add title in center
        const title = "Provider Overview List";
        doc.setFontSize(16);
        const pageWidth = doc.internal.pageSize.getWidth();
        const titleWidth = doc.getTextWidth(title);
        const titleX = (pageWidth - titleWidth) / 2;
        doc.text(title, titleX, 15);

        // Convert PNG image to Base64
        const logoUrl = logoPDF;
        let logoData;
        try {
          logoData = await getBase64ImageFromUrl(logoUrl);
        } catch (error) {
          console.error("Error converting image to Base64", error);
        }

        // Add logo image at top right if available
        if (logoData) {
          const imageWidth = 40; // Adjust dimensions as needed
          const imageHeight = 10;
          const marginRight = 15;
          doc.addImage(
            logoData,
            "PNG",
            pageWidth - imageWidth - marginRight,
            10,
            imageWidth,
            imageHeight
          );
        }

        // Prepare table headers and rows
        const tableColumn = [
          // "S.no",
          "Client Contact",
          "Provider",
          "ABN/NZBN",
          "Clients Assigned",
          "Status",
          "Reason",
          "State",
          "Workers No.",
          "Creation Date",
          "Approval Date",
          "Renewal date",
          "Lifetime Value",
        ];

        const getPdfStatusLabel = (status) => {
          if (!status) return "-";
          if (status === "Assigned") return "Registered";
          if (status === "Registered") return "Self-Registered";
          if (status === "No-clients") return "Self-Registered";
          if (status === "Closed" || status === "Inactive") return "Deactivated";
          return status;
        };

        const tableRows = allReportData?.providers?.map((row, index) => [
          // index + 1,
          row.client_contact_name || "-",
          row.provider_trading_name,
          row.provider_abn_nzbn,
          row.client_trading_name || "-",
          getPdfStatusLabel(row.status),
          row.change_reason || "-",
          row.state_name || "-",
          row.worker_assigned || "-",
          row.creation_date
            ? moment(row.creation_date).format("DD/MM/YYYY")
            : "-",
          row.last_doc_approval_date
            ? moment(row.last_doc_approval_date).format("DD/MM/YYYY")
            : "-",
          row.renewal_date
            ? moment(row.renewal_date).format("DD/MM/YYYY")
            : "-",
          row.life_time_value || "-",
        ]);

        // Add table starting below the header
        // doc.autoTable({
        //   head: [tableColumn],
        //   body: tableRows,
        //   startY: 25,
        //   styles: { fontSize: 10 }, // Reduce font size for better fit
        //   headStyles: {
        //     fillColor: "#E5F3FE",
        //     textColor: "#464A53",
        //     overflow: "visible",
        //   },
        //   bodyStyles: {
        //     textColor: "#000000",
        //     overflow: "linebreak",
        //   },
        //   columnStyles: {
        //     0: { cellWidth: "auto" },
        //     1: { cellWidth: "auto" },
        //     2: { cellWidth: "auto" },
        //     3: { cellWidth: "auto" },
        //     4: { cellWidth: "auto" },
        //     5: { cellWidth: "auto" },
        //     6: { cellWidth: "auto" },
        //     7: { cellWidth: "auto" },
        //   },
        // });
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 25,
          styles: {
            fontSize: 8, // Reduce font size
            cellPadding: 2,
            overflow: "linebreak", // Enable text wrapping
          },
          headStyles: {
            fillColor: "#E5F3FE",
            textColor: "#464A53",
            fontSize: 9, // Reduce header font size
          },
          bodyStyles: {
            textColor: "#000000",
            fontSize: 8, // Reduce body font size
            cellPadding: 2,
            overflow: "linebreak",
          },
          columnStyles: {
            0: { cellWidth: "auto" },
            1: { cellWidth: "auto" },
            2: { cellWidth: "auto" },
            3: { cellWidth: "wrap" },
            4: { cellWidth: "wrap" },
            5: { cellWidth: "wrap" },
            6: { cellWidth: "wrap" },
            7: { cellWidth: "wrap" },
            8: { cellWidth: "wrap" },
            9: { cellWidth: "wrap" },
            10: { cellWidth: "wrap" },
            11: { cellWidth: "wrap" },
          },
          margin: { top: 30, left: 10, right: 10 }, // Adjust margins
          pageBreak: "auto", // Automatically move to the next page when needed
        });

        // Save the PDF
        doc.save("provider_overview.pdf");

        // Save the PDF
        doc.save("provider_overview.pdf");
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  const closeDownloadSuccessPdf = () => {
    setPdfDownloadSuccessDialog(false);
    setTimeout(() => {
      setCheckPdfLoad(true);
    }, 1000);
  };

  useEffect(() => {
    if (processedCsvData.length > 0) {
      csvLinkRef.current.link.click();
    }
    return () => {
      setCustReportName(""); // Reset state on cleanup (unmount or dependency change)
    };
  }, [processedCsvData]); // Runs when processedCsvData updates


  const inputChangeHandler = (e) => {

    setCustReportName(e)
    setCustErrMsg("")

    // Clear the error if there's any
    // setErrors(prevErrors => ({ ...prevErrors, removeUserMsgError: "" }));
  };

  const handleFavReports = (reportType, reportTitle, isFav) => {
    setSelectReport(!selectReport)
    const payload = {
      user_id: userId, // Dynamically passed userId
      report_type: reportType, // Dynamically passed reportType
      is_favourite: isFav,
      user_type: userType, // Dynamically passed userType
      report_dashboard: "provider",
      report_title: reportTitle
    }

    dispatch(ProviderFavouriteReportsOrNot(payload))
      .then((res) => {
        if (res.status) {
          // Handle the success response here
          // Optionally update UI or give feedback to the user
          // For example, you can update a state variable to show the report is favorited
        } else {
          // Handle non-successful status codes here
          console.error('Failed to favorite report:', res.message || 'Unknown error');
        }
      })
      .catch((error) => {
        // Handle the error (e.g., network error, server error, etc.)
        console.error('Error favoriting report:', error);
        // Optionally show a user-friendly message
      });
  }
  useEffect(() => {
    if (favReport) {
      setSelectReport(favReport.some((ele) => ele.report_type == "providers-overview"))
    }
  }, [favReport])


  useEffect(() => {
    if (cstRep) {

      setSaveCustomRep(cstRep.some((ele) => ele.report_type == "providers-overview"))
      if (cstRep.some((ele) => ele.report_type == "providers-overview")) {
        setCustSuccessMsg(true)
        const data = cstRep[0]?.apply_filters
        // setfilterpage(data.page)
        // setfilterlimit(data.limit)
        // setFiltersort(data.sort)
        // setFilterOrder(data.order)
        // setClient_org_ids(JSON.parse(data.client_org_ids))
        // setCreated_date_range(data.created_date_range)
        // setFilterStatus(data.status)
        // setRenewalDate(data.renewal_date_range)

        SetgetAllinvitedData({
          client_org_ids: data?.client_org_ids ? JSON.parse(data.client_org_ids) : [],
          provider_org_ids: data?.provider_org_ids ? JSON.parse(data?.provider_org_ids) : [],
          provider_type_ids: data?.provider_type_ids ? JSON.parse(data?.provider_type_ids) : [],
          page: data?.page,
          limit:  data?.limit,
          sort: data?.sort,
          order: data?.order,
          status: data?.status,
          approval_date_range: data?.approval_date_range,
          renewal_date_range: data?.renewal_date_range,
         
        });
      
      }
    }
  }, [cstRep])
  const handleConfirm = () => {
    unSaveSetIsOpen(true);
  }
  const handleUpdateCustomRep = () => {
    setRemoveDialog(true);
  }
  const onDialogCloseRemove = () => {
    setRemoveDialog(false);

  };
  const onDialogCloseUnSave = () => {
    unSaveSetIsOpen(false);

  };
  const onCloseDetails=()=>{
    setCustSuccessMsg(false)
      navigate(-1); 
    setOpenSuccessDialog("")
  }
  const handleCustom = (reportType, reportTitle, isCustom, type) => {
    if (!saveCustomRep && !custReportName) {
      setCustErrMsg("Please enter custom report name")
      return
    }
    const basePayload = {
      is_custom: isCustom,
      user_id: userId,
      report_type: reportType,
      user_type: userType,
      report_dashboard: "provider",
      custom_report_name: cstRep?.[0]?.custom_report_name ? cstRep?.[0]?.custom_report_name : custReportName,
      report_title: reportTitle,
      apply_filters: {
        ...getAllinvitedData,
        client_org_ids: JSON.stringify(
          getAllinvitedData.client_org_ids?.map((item) => item?.organisation_id)
        ),
        provider_org_ids: JSON.stringify(
          getAllinvitedData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
        provider_type_ids: JSON.stringify(getAllinvitedData.provider_type_ids),

      }
    };

    if (type == "update" || saveCustomRep) {
      basePayload.report_custom_id = cstRep?.[0]?.report_custom_id;
    }

    const payload = basePayload



    dispatch(ProviderCustomReports(payload))
      .then((res) => {
        if (res.status) {
          // Handle the success response here
          if (type == "createOrDelete") {
            setSaveCustomRep(!saveCustomRep)
            setCustReportName("")
            setOpenSuccessDialog(true)
            // navigate( {
            //   state: { favReport }
            // });
            //here i want to upload empty navigation data where i want to empty of cstRep data
            unSaveSetIsOpen(false);
          } else if (type == "update") {
            setSaveCustomRep(true)
            setRemoveDialog(false)
            setOpenSuccessDialog(true)
          }

        } else {
          // Handle non-successful status codes here
          console.error('Failed to favorite report:', res.message || 'Unknown error');
        }
      })
      .catch((error) => {
        // Handle the error (e.g., network error, server error, etc.)
        console.error('Error favoriting report:', error);
        // Optionally show a user-friendly message
      });



  }

  return (
    <React.Fragment>
      <div className="flex justify-between mb-5 border-b border-gray-200 pb-5">
        <Heading>Providers Overview</Heading>
        <div className="flex gap-3">
          <button
            onClick={generateProviderOverview}
            disabled={isGenerating}
            className="bg-[#5786CC] text-white text-xs px-3 py-1 rounded-md transition ml-2 flex items-center justify-center min-w-[94px] disabled:opacity-60 disabled:cursor-not-allowed hover:bg-[#3f6ab4]"
            >
            {isGenerating ? <ThreeDotLoader /> : "Generate"}
          </button>
        {/* <BtnLight
            className="h-10 w-10 flex items-center justify-center gap-2 text-12">
            {selectReport ?
              (<svg
                onClick={() => handleFavReports("providers-overview", "Providers Overview", false)}
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_15736_74961)">
                  <path
                    d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                    fill="#FDB022"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15736_74961">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0.333984 0.800781)"
                    />
                  </clipPath>
                </defs>
              </svg>)
              :
              (
                <svg onClick={() => handleFavReports("providers-overview", "Providers Overview", true)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.40156 2.8778C9.59363 2.48869 9.68967 2.29413 9.82004 2.23197C9.93347 2.17789 10.0653 2.17789 10.1787 2.23197C10.3091 2.29413 10.4051 2.48869 10.5972 2.8778L12.4194 6.56944C12.4761 6.68432 12.5045 6.74176 12.5459 6.78635C12.5826 6.82584 12.6266 6.85783 12.6754 6.88056C12.7306 6.90623 12.794 6.91549 12.9208 6.93402L16.9968 7.5298C17.4261 7.59253 17.6407 7.6239 17.74 7.72874C17.8264 7.81995 17.8671 7.94529 17.8506 8.06985C17.8317 8.21302 17.6763 8.36436 17.3656 8.66702L14.4172 11.5387C14.3253 11.6282 14.2794 11.673 14.2497 11.7263C14.2235 11.7734 14.2066 11.8252 14.2001 11.8788C14.1928 11.9393 14.2036 12.0025 14.2253 12.129L14.921 16.1851C14.9944 16.6129 15.031 16.8269 14.9621 16.9538C14.9021 17.0642 14.7955 17.1417 14.6719 17.1646C14.5299 17.1909 14.3378 17.0899 13.9536 16.8879L10.3097 14.9716C10.1961 14.9119 10.1394 14.882 10.0796 14.8703C10.0266 14.8599 9.97213 14.8599 9.91918 14.8703C9.85937 14.882 9.8026 14.9119 9.68906 14.9716L6.04512 16.8879C5.66095 17.0899 5.46886 17.1909 5.32683 17.1646C5.20325 17.1417 5.09662 17.0642 5.03663 16.9538C4.96768 16.8269 5.00437 16.6129 5.07774 16.1851L5.77342 12.129C5.79511 12.0025 5.80595 11.9393 5.79862 11.8788C5.79212 11.8252 5.77528 11.7734 5.74902 11.7263C5.71937 11.673 5.67341 11.6282 5.5815 11.5387L2.63315 8.66702C2.3224 8.36436 2.16703 8.21302 2.14812 8.06985C2.13167 7.94529 2.17231 7.81995 2.25872 7.72874C2.35804 7.6239 2.57266 7.59253 3.00189 7.5298L7.07794 6.93402C7.2047 6.91549 7.26808 6.90623 7.32328 6.88056C7.37215 6.85783 7.41615 6.82584 7.45284 6.78635C7.49427 6.74176 7.52262 6.68432 7.57933 6.56944L9.40156 2.8778Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              )

            }

          </BtnLight>
           */}
          {/* <BtnLight onClick={handleConfirm} className="h-10 w-40 flex items-center justify-center gap-2 text-12">
            {saveCustomRep ? "Remove custom report" : "Save as custom report"}
          </BtnLight>
          {saveCustomRep && (
            <BtnLight onClick={handleUpdateCustomRep} className="h-10 w-40 flex items-center justify-center gap-2 text-12">
              {saveCustomRep && "Update custom report"}
            </BtnLight>
          )} */}
  
          <div className="export-dropdow">
            <Dropdown title="Export" className="dropdown-btn">
              <Dropdown.Item
                eventKey="a"
                onClick={() => handleExport("csv")}
                className="text-gray-900 font font-medium"
              >
                CSV
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="b"
                onClick={() => handleExport("excel")}
                className="text-gray-900 font font-medium"
              >
                Excel
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="c"
                onClick={() => handleExport("pdf")}
                className="text-gray-900 font font-medium"
              >
                PDF
              </Dropdown.Item>
            </Dropdown>
            {/* HIDDEN CSVLink - clicked programmatically for CSV export */}
            {processedCsvData && (
              <CSVLink
                data={processedCsvData}
                headers={csvHeaders}
                filename="tableData.csv"
                className="hidden"
                ref={csvLinkRef}
                target="_blank"
              />
            )}
          </div>
        </div>
      </div>
      <div className="flex gap-1 cstm-dropdown">
        <div>
          <AllProviderMultiSelectDropdown
            title="Provider"
            updateFilter={updateFilter}
            selectedProviders={getAllinvitedData?.provider_org_ids}
            Path="admin"
          />
        </div>
        <div>
          <ProvideTyperMultiSelectDropdown
            title="Provider type"
            updateFilter={updateFilter}
            provider_org_ids={getAllinvitedData?.provider_org_ids}
          />
        </div>
        <div>
          <AssignClientMultiSelectDropdown
            title="Client assigned"
            updateFilter={updateFilter}
            provider_org_ids={getAllinvitedData?.provider_org_ids}
          />
        </div>
        <div>
          <StatusMultiSelectDropdown
            statusData={["Compliant", "Non-Compliant", "Invited"]}
            title={"Status"}
            updateFilter={updateFilter}
          />
        </div>
        {/* <div>
          <DateMultiSelectDropdown
            title={"Creation date"}
            type={"creation_date_range"}
            setKey={setKey}
            dateMinMax={dateMinMax}
            updateFilter={updateFilter}
            // setDate_range={setDate_range}
          />
        </div>
        <div>
          <DateMultiSelectDropdown
            title={"Approval date"}
            type={"approval_date_range"}
            setKey={setKey}
            dateMinMax={dateMinMax}
            updateFilter={updateFilter}
            // setDate_range={setDate_range}
          />
        </div>
        <div>
          <DateMultiSelectDropdown
            title={"Renewal date"}
            type={"renewal_date_range"}
            setKey={setKey}
            dateMinMax={dateMinMax}
            updateFilter={updateFilter}
            // setDate_range={setDate_range}
          />
        </div> */}
        <div>
          <DateMultiSelectDropdown
            title="Creation date"
            type="creation_date_range"
            setKey={setKey}
            dateMinMax={dateMinMax.creation_date_range}
            updateFilter={updateFilter}
          />
        </div>
        <div>
          <DateMultiSelectDropdown
            title="Approval date"
            type="approval_date_range"
            setKey={setKey}
            dateMinMax={dateMinMax.approval_date_range}
            updateFilter={updateFilter}
          />
        </div>
        <div>
          <DateMultiSelectDropdown
            title="Renewal date"
            type="renewal_date_range"
            setKey={setKey}
            dateMinMax={dateMinMax.renewal_date_range}
            updateFilter={updateFilter}
          />
        </div>
      </div>

      <div
        className="grid  grid-cols-12 border border-gray-100 rounded-xl p-6 mt-5 flex-wrap gap-6 items-center justify-around">
          <div className="col-span-8">
            <LineChart
          chartData={Array.isArray(reportData?.statistics?.monthlyStatus)
            ? reportData.statistics.monthlyStatus
            : []}
          count={reportData?.total}
          activeCount={reportData?.statistics?.counts}
        />
          </div>
          <div className="col-span-4">
            <PieChart chartData={reportData?.statistics?.monthlyStatus} />
          </div>
      </div>
      <DataList
        data={reportData}
        handleSort={handleSort}
        getAllinvitedData={getAllinvitedData}
      />
      <div className="flex justify-between mt-3">
        <div className={!loadData ? "pointer-events-none opacity-60" : ""}>
          <Pagination
            totalCount={reportData?.total || 0}
            pageNumber={getAllinvitedData.page}
            displayPage={reportData?.providers?.length || 0}
            UpdatePageLimit={SetgetAllinvitedData}
            allfilters={getAllinvitedData}
          />
        </div>
        {reportData?.total > 0 && (
          <ReactPaginate
            className={`flex justify-content-end p-2 align-items-center pagination-wrap ${
              !loadData ? "pointer-events-none opacity-60" : ""
            }`}
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageChange}
            containerClassName={"pagination"}
            activeClassName={"active"}
            previousLinkClassName={"prev-link"}
            nextLinkClassName={"page-link"}
            breakLinkClassName={"prev-link"}
            previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
            nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
            pageLinkClassName={"px-4 rounded-md"}
            activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
            disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
            renderOnZeroPageCount={null}
            forcePage={getAllinvitedData?.page - 1}
          />
        )}
      </div>

      {!loadData && (
        <div className="mt-4 flex justify-center">
          <ThreeDotBouncing />
        </div>
      )}
      <Dialog
        isOpen={pdfDownloadSuccessDialog}
        onClose={closeDownloadSuccessPdf}
        onRequestClose={closeDownloadSuccessPdf}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          {!checkPdfLoad && (
            <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.894531"
                  y="0.585938"
                  width="48"
                  height="48"
                  rx="24"
                  fill="#D1FADF"
                />
                <path
                  d="M26.8945 14.8555V18.986C26.8945 19.5461 26.8945 19.8261 27.0035 20.04C27.0994 20.2282 27.2524 20.3811 27.4405 20.477C27.6545 20.586 27.9345 20.586 28.4945 20.586H32.6251M28.8945 25.5859H20.8945M28.8945 29.5859H20.8945M22.8945 21.5859H20.8945M26.8945 14.5859H21.6945C20.0144 14.5859 19.1743 14.5859 18.5326 14.9129C17.9681 15.2005 17.5091 15.6595 17.2215 16.224C16.8945 16.8657 16.8945 17.7058 16.8945 19.3859V29.7859C16.8945 31.4661 16.8945 32.3062 17.2215 32.9479C17.5091 33.5124 17.9681 33.9713 18.5326 34.259C19.1743 34.5859 20.0144 34.5859 21.6945 34.5859H28.0945C29.7747 34.5859 30.6148 34.5859 31.2565 34.259C31.821 33.9713 32.2799 33.5124 32.5676 32.9479C32.8945 32.3062 32.8945 31.4661 32.8945 29.7859V20.5859L26.8945 14.5859Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          )}
          {checkPdfLoad && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            {checkPdfLoad
              ? `${
                  successText.charAt(0).toUpperCase() + successText.slice(1)
                } downloading..`
              : `${
                  successText.charAt(0).toUpperCase() + successText.slice(1)
                } downloaded successfully!`}
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => closeDownloadSuccessPdf()}>Close</BtnLight>
        </div>
      </Dialog>

       {/* Dialogs for Custom reports */}
       <Dialog
        isOpen={unSaveDialogIsOpen}
        onClose={onDialogCloseUnSave}
        onRequestClose={onDialogCloseUnSave}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-warning-100 flex items-center justify-center">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 3.5v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.26 8.5 8.54 8.5 9.1 8.5h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.5m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H9.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7.5 14.26 7.5 14.54 7.5 15.1v6.4m14-11.675V16.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 19.22 3.5 18.38 3.5 16.7V8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.78 3.5 6.62 3.5 8.3 3.5h6.874c.49 0 .734 0 .965.055.204.05.399.13.578.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963z"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <h4 className="text-base text-gray-900 font-semibold text-center mt-4">
            {saveCustomRep ? "Are you removing this custom report" : "Are you saving the custom report?"}

          </h4>
          {!saveCustomRep && (

            <div style={{ marginTop: "10px" }}>
              <Input
                className="h-9 w-full"
                placeholder="Type here"
                value={custReportName}
                name="message"
                inputchangehandler={(e) => inputChangeHandler(e)}
              />
              {custErrMsg && (
                <p className="text-xs text-red-600 mt-2">
                  {custErrMsg}
                </p>
              )}
            </div>
          )}
        </div>

        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => onDialogCloseUnSave()} className="mr-1.5">
            Cancel
          </BtnLight>
          <BtnPrimary className="ml-1.5" onClick={() => handleCustom("providers-overview", "Providers Overview", saveCustomRep ? false : true, "createOrDelete")}>
            Confirm
          </BtnPrimary>
        </div>
      </Dialog>
      <Dialog
        isOpen={removeDilaog}
        onClose={onDialogCloseRemove}
        onRequestClose={onDialogCloseRemove}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-warning-100 flex items-center justify-center">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 3.5v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.26 8.5 8.54 8.5 9.1 8.5h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.5m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H9.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7.5 14.26 7.5 14.54 7.5 15.1v6.4m14-11.675V16.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 19.22 3.5 18.38 3.5 16.7V8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.78 3.5 6.62 3.5 8.3 3.5h6.874c.49 0 .734 0 .965.055.204.05.399.13.578.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963z"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <h4 className="text-base text-gray-900 font-semibold text-center mt-4">
            {saveCustomRep && "Are you updating this custom report"}
          </h4>
        </div>

        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => onDialogCloseRemove()} className="mr-1.5">
            Cancel
          </BtnLight>
          <BtnPrimary className="ml-1.5" onClick={() => handleCustom("providers-overview", "Providers Overview", true, "update")}>
            Confirm
          </BtnPrimary>
        </div>
      </Dialog>
      <Dialog
        isOpen={openSuccessDialog}
        onClose={onCloseDetails}
        onRequestClose={onCloseDetails}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9.5 16l2 2 4.5-4.5M14.5 2H9.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4.5 4.28 4.5 5.12 4.5 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.78 22 7.62 22 9.3 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V8l-6-6z"
                stroke="#344054"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
     
            {`Custom reports ${custSuccessMsg?"updated":"saved"}  successfully!`}
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnPrimary onClick={onCloseDetails}>Close</BtnPrimary>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default ProvidersComplianceChecklist;
